import { Injectable } from "@angular/core"
import { createEffect, ofType, Actions } from "@ngrx/effects"
import { createAction, props, createReducer, on, createSelector } from "@ngrx/store"
import { map, catchError, of, switchMap } from "rxjs"
import { IEmployee } from "src/app/employee/employee"
import { AppStateInterface } from "../appState.interface"
import { EmployeeService } from "src/app/employee/services/employee.service"
import { TimeSpan } from "src/app/shared/helpers/time-span"

export interface CurrentEmployeeStateInterface {
  isLoading: boolean,
  currentEmployee: IEmployee,
  error: string | null
}

// actions

export const getCurrentEmployee = createAction('[CurrentEmployee] Get CurrentEmployee')
export const getCurrentEmployeeSuccess = createAction('[CurrentEmployee] Get CurrentEmployee success', props<{currentEmployee: IEmployee}>())
export const getCurrentEmployeeFailure = createAction('[CurrentEmployee] Get CurrentEmployee failure', props<{error: string}>())

// states
export const initialState: CurrentEmployeeStateInterface = {
  isLoading: false,
  currentEmployee: null,
  error: null
}

// reducers
export const currentEmployeeReducers = createReducer(
  initialState,
  on(getCurrentEmployee, (state) => ({...state, isLoading: true})),
  on(getCurrentEmployeeSuccess, (state,action) => ({
    ...state, 
    isLoading: false,
    currentEmployee: action.currentEmployee
  })),
  on(getCurrentEmployeeFailure, (state,action) => ({
    ...state, 
    isLoading: false,
    error: action.error
  }))
)

export const selectFeature = (state: AppStateInterface) => state.currentEmployee

// Selectors
export const isLoadingSelector = createSelector(selectFeature, (state) => state.isLoading); 
export const currentEmployeeSelector = createSelector(selectFeature, (state) => state.currentEmployee); 
export const errorSelector = createSelector(selectFeature, (state) => state.error); 

// effects
@Injectable()
export class CurrentEmployeeEffects {
  getCurrentEmployee$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(getCurrentEmployee),
        // switchMap: ein neuerer Dispatch bricht einen laufenden Request ab, damit im Store
        // immer der zuletzt geladene Serverstand landet.
        switchMap(() =>{
          return this.employeeService
            .getEmployeeDetails()
            .pipe(
              map(employee => {
                return {
                  ...employee,
                  flexTimeBalanceObj: TimeSpan.parse(employee.flexTimeBalance).getAsTimeObject(),
                  preWorkTimeBalanceObj: TimeSpan.parse(employee.preWorkTimeBalance).getAsTimeObject(),
                  overtimeBalanceObj: TimeSpan.parse(employee.overtimeBalance ?? "00:00:00").getAsTimeObject()
                }
              }),
              map((employee) => getCurrentEmployeeSuccess({currentEmployee: employee})),
              catchError((error) => of(getCurrentEmployeeFailure({error: error})))
            );
          })
        // take(1) entfernt: es stand am Ende der aeusseren actions$-Pipe und beendete damit
        // den ganzen Effect nach dem ersten Aufruf. Spaetere getCurrentEmployee-Dispatches
        // (Abwesenheitsantrag, Zeiterfassung Start/Stop) blieben dadurch wirkungslos.
      )
  });

  constructor(
    private actions$: Actions,
    private employeeService: EmployeeService
  ) {
    
  }
}